import * as XLSX from "xlsx";

const JOB_TEMPLATE_COLUMNS = [
	"name",
	"pickup",
	"delivery",
	"vehicle_identification",
	"cost",
	"ignore",
	"penalty_cost",
	"pickup_to_delivery_absolute_detour_limit",
	"pickup_to_delivery_time_limit",
	"pickup_to_delivery_relative_detour_limit",
];

const JOB_TEMPLATE_EXAMPLE = {
	name: "Job_001",
	pickup: "PICKUP_001",
	delivery: "DELIVERY_001",
	vehicle_identification: "VEHICLE_001",
	cost: 100,
	ignore: false,
	penalty_cost: 0,
	pickup_to_delivery_absolute_detour_limit: "00:30:00",
	pickup_to_delivery_time_limit: "02:00:00",
	pickup_to_delivery_relative_detour_limit: 0.5,
};

export function downloadJobUploadTemplate(filename = "plantilla_trabajos.xlsx") {
	const workbook = XLSX.utils.book_new();
	const worksheet = XLSX.utils.json_to_sheet([JOB_TEMPLATE_EXAMPLE], {
		header: JOB_TEMPLATE_COLUMNS,
	});
	worksheet["!cols"] = JOB_TEMPLATE_COLUMNS.map((column) => ({
		wch: Math.max(column.length + 4, 18),
	}));
	XLSX.utils.book_append_sheet(workbook, worksheet, "jobs");
	XLSX.writeFile(workbook, filename);
}

export {JOB_TEMPLATE_COLUMNS, JOB_TEMPLATE_EXAMPLE};
